import { makeCrud } from "./crud";
import { request } from "./http";

const crud = makeCrud("quotations");

export const fetchQuotations  = (filters, signal) => crud.list(filters, signal);
export const fetchQuotation   = crud.get;
export const createQuotation  = crud.create;
export const updateQuotation  = crud.update;
export const deleteQuotation  = crud.remove;

export const updateQuotationStatus = (id, status) =>
  request(`/quotations/${id}/status`, { method: "PATCH", body: { status } });

/** Accepted quotation → invoice. */
export const convertQuotationToInvoice = (id) =>
  request(`/quotations/${id}/convert`, { method: "POST" });
